<div
  class="mx-xs-3 user-access-message d-flex flex-column justify-content-center align-items-center"
>
  <div class="text-container">
    <div class="icon-container ml-auto mr-auto mb-3">
      <img src="assets/svg/ico-key-gray-circle-white.svg" class="user-icon" />
    </div>
    <div class="text-center mb-4">
      <h2 class="heading">{{ title }}</h2>
      <p class="empty-box">
        {{ description }}
      </p>
    </div>
  </div>
</div>
